/* =============================================================================
   assets/evs-fixes.js

   Fiche produit : la section des avantages s'affiche ouverte, juste apres le
   paragraphe d'accroche de la description ; les autres sections restent
   repliees. Demande d'Isma, 26/09/2026.

   La remontee elle-meme est faite en CSS (assets/evs-fixes.css, ordre flex),
   pour qu'il n'y ait pas de saut visuel au chargement. Ce script ne fait que
   l'ouvrir. Sans JavaScript, la section reste repliee comme avant : rien
   n'est perdu.

   La categorie "love" est posee par snippets/evs-description-sections.liquid
   a partir des mots du titre (avantages / advantages / Vorteile / ventajas...
   dans les 15 langues), donc aucune fiche ni traduction n'est a retoucher.
   ========================================================================== */
(function () {
  'use strict';

  function open() {
    document.querySelectorAll('.evs-dsec').forEach(function (bloc) {
      var av = bloc.querySelector('.evs-dsec__item--love');
      if (av && !av.open) av.open = true;
    });
  }

  if (document.readyState !== 'loading') open();
  else document.addEventListener('DOMContentLoaded', open);
})();

/* -----------------------------------------------------------------------------
   Bloc « Product advantages » (metafield custom.product_benefits), 03/10/2026 :
   Isma veut une coche devant chaque avantage plutot qu'une pastille.

   Le contenu vient de metafield_tag, on ne peut donc ni ajouter de classe dans
   la fiche ni enchainer un filtre dans le reglage du bloc (Shopify n'accepte
   qu'un filtre par source dynamique). Les pseudo-elements ::before ne sont pas
   peints dans ce bloc du theme, et une coche en caractere ✓ dependrait des
   polices installees sur l'appareil : on insere donc une vraie icone SVG.

   La classe evs-adv--ck n'est posee que si le script tourne ; sans JavaScript
   la liste garde ses puces normales, rien n'est casse.
   -------------------------------------------------------------------------- */
(function () {
  'use strict';

  var CK = "<svg class='evs-adv-ck' width='16' height='16' viewBox='0 0 24 24' fill='none' " +
           "stroke='currentColor' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' " +
           "aria-hidden='true' focusable='false'><path d='m4.5 12.8 5 5L19.5 6.5'/></svg>";

  function coches(racine) {
    (racine || document).querySelectorAll(
      '.disclosure__content .metafield-rich_text_field ul'
    ).forEach(function (ul) {
      if (ul.classList.contains('evs-adv--ck')) return;
      var items = ul.children, pose = false;
      for (var i = 0; i < items.length; i++) {
        var li = items[i];
        if (li.tagName !== 'LI' || li.querySelector('.evs-adv-ck')) continue;
        li.insertAdjacentHTML('afterbegin', CK);
        pose = true;
      }
      if (pose) ul.classList.add('evs-adv--ck');
    });
  }

  function init() {
    coches(document);
    /* Le bloc est re-rendu au changement de variante (section rendering API). */
    document.addEventListener('variant:change', function () { coches(document); });
    if (window.MutationObserver) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { coches(document); return; }
        }
      });
      var cible = document.querySelector('.product-info') || document.body;
      mo.observe(cible, { childList: true, subtree: true });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* 14/10/2026 : essai abandonne. Faire contenir les flottants par tous les blocs de la
   colonne (display:flow-root) corrigeait bien les ecarts de 49 px sous la ligne de
   flottaison, mais creait l'effet inverse ailleurs : un bloc qui etablit un contexte de
   formatage passe SOUS les flottants qui s'echappent du bloc precedent, et des ecarts de
   24 a 36 px apparaissaient en haut de colonne. Seul le bloc du selecteur de taille est
   traite, dans assets/vpg.css, ou la mesure confirme le gain sans effet de bord. */
